<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-end mb-4">
        <point-adjustment-dialog
          @adjustment-completed="onAdjustmentCompleted"
        ></point-adjustment-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <point-adjustment-history
          ref="historyComponent"
        ></point-adjustment-history>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PointAdjustmentDialog from "@/components/PointAdjustmentDialog.vue";
import PointAdjustmentHistory from "@/components/PointAdjustmentHistory.vue";

/**
 * Vue principale pour la gestion des ajustements de points
 * Combine le dialog d'ajustement et l'historique
 */
export default {
  name: "PointAdjustmentView",
  components: {
    PointAdjustmentDialog,
    PointAdjustmentHistory,
  },
  methods: {
    /**
     * Rafraîchit l'historique après un ajustement réussi
     */
    onAdjustmentCompleted() {
      if (this.$refs.historyComponent) {
        this.$refs.historyComponent.fetchHistory();
      }
    },
  },
};
</script>
